/**
 * Ostoskorin kaiverrus-cleanup
 * Poistaa automaattisesti kaiverrustuotteen kun päätuote poistetaan
 */
class CartEngravingCleanup {
  constructor() {
    this.ENGRAVING_VARIANT_ID = 52708460396877;
    this.isCleaningUp = false;
    this.init();
  }
  
  init() {
    document.documentElement.addEventListener('cart:change', (event) => {
      if (this.isCleaningUp) {
        return;
      }
      
      const baseEvent = event.detail?.baseEvent;
      if (baseEvent === 'line-item:change' || baseEvent === 'line-item:remove') {
        this.checkAndRemoveOrphanedEngravings(event.detail.cart);
      }
    });
  }
  
  async checkAndRemoveOrphanedEngravings(cart) {
    if (!cart || !cart.items) {
      return;
    }
    
    const mainProductIds = new Set(
      cart.items
        .filter(item => item.variant_id !== this.ENGRAVING_VARIANT_ID)
        .map(item => String(item.variant_id))
    );
    
    const engravingItems = cart.items.filter(item => 
      item.variant_id === this.ENGRAVING_VARIANT_ID
    );
    
    const orphanedEngravings = [];
    
    for (const engravingItem of engravingItems) {
      const linkedProductId = engravingItem.properties?._Tuote;
      
      if (linkedProductId && !mainProductIds.has(String(linkedProductId))) {
        orphanedEngravings.push(engravingItem);
      }
    }
    
    if (orphanedEngravings.length > 0) {
      await this.removeItems(orphanedEngravings);
    }
  }
  
  async removeItems(items) {
    this.isCleaningUp = true;
    
    try {
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { 
        bubbles: true, 
        detail: { sections: sectionsToBundle } 
      }));
      
      const updates = {};
      items.forEach(item => {
        updates[item.key] = 0;
      });
      
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          updates: updates,
          sections: sectionsToBundle.join(',')
        })
      });
      
      if (response.ok) {
        const data = await response.json();
        const cartData = await (await fetch('/cart.js')).json();
        cartData.sections = data.sections;
        
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'cart:updated',
            cart: cartData
          }
        }));
      }
    } catch (error) {
      // Silent fail
    } finally {
      setTimeout(() => {
        this.isCleaningUp = false;
      }, 500);
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CartEngravingCleanup();
  });
} else {
  new CartEngravingCleanup();
}